// ----------------------------------------------------------------------

export default function Switch(theme) {
  return {
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 44,
          height: 24,
          padding: 0,
          display: 'flex',
          '&:active': {
            '& .MuiSwitch-thumb': {
              width: 22,
            },
            '& .MuiSwitch-switchBase.Mui-checked': {
              transform: 'translateX(18px)',
            },
          },
        },
        switchBase: {
          padding: 2,
          '&.Mui-checked': {
            transform: 'translateX(20px)',
            color: '#FFFFFF',
            '& + .MuiSwitch-track': {
              opacity: 1,
              backgroundColor: theme.palette.primary.main,
            },
          },
        },
        thumb: {
          boxShadow: '0 2px 4px 0 rgba(0, 35, 11, 0.2)',
          width: 20,
          height: 20,
          borderRadius: 10,
          transition: theme.transitions.create(['width'], {
            duration: 200,
          }),
        },
        track: {
          borderRadius: 24 / 2,
          opacity: 1,
          backgroundColor: theme.palette.grey[300],
          boxSizing: 'border-box',
        },
      },
    },
  };
}
